/* eslint-disable import/no-mutable-exports */
import { message as antdMessage, Modal as antdModal, notification as antdNotification, App } from "antd";

let message = antdMessage;
let notification = antdNotification;

const { ...resetFns } = antdModal;
let modal = resetFns;

/**
 * 设置全局的静态方法
 * @see https://ant.design/components/app
 * @see https://ant.design/docs/blog/why-not-static
 * @returns {null}
 */
export function StaticAntd() {
    const staticFunctions = App.useApp();

    /* Usage 1 */
    message = staticFunctions.message;
    notification = staticFunctions.notification;
    modal = staticFunctions.modal;

    /* Usage 2 */
    // 扩展 window 对象
    if (window) {
        window.$message = message;
        window.$modal = modal;
        window.$notification = notification;
    }

    return null;
}

export { message, modal, notification };
